import { render, staticRenderFns } from "./mContact.vue?vue&type=template&id=48bba292&scoped=true&"
import script from "./mContact.vue?vue&type=script&lang=js&"
export * from "./mContact.vue?vue&type=script&lang=js&"
import style0 from "./mContact.vue?vue&type=style&index=0&id=48bba292&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bba292",
  null
  
)

export default component.exports